import React, { Component } from 'react';
import { Row, Col, Card } from 'antd';
import { Link } from 'react-router-dom'
import 'antd/dist/antd.css';
import '../App.css'

class MyTripsMenu extends Component {

    render() {
        return (
            <div>
                <br/>
                <Row gutter={16}>
                    <Col md={{ span: 8, offset: 4}}>
                        <Card>
                            <h1 style={{ color: '#0099ff' }}>
                                <Link to="/trips-posted">
                                    Trips you posted
                                </Link>
                            </h1>
                        </Card>
                    </Col>
                    {/* <Col md={{ span: 8 }}>
                        <Card>
                            <h1 style={{ color: '#0099ff' }}>
                                <Link to="/requests-posted">
                                    Requests you posted
                                </Link>
                            </h1>
                        </Card>
                    </Col> */}
                    <Col md={{ span: 8 }}>
                        <Card>
                            <h1 style={{ color: '#0099ff' }}>
                                <Link to="/trips-booked">
                                    Trips you booked
                                </Link>
                            </h1>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default MyTripsMenu;
